import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import "./Addcart.css";
import product1 from "../assets/images/m4.png";
import cart from "../assets/images/cart.png";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DiscountIcon from "@mui/icons-material/Discount";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import treatment from "../assets/images/treatment.png";

export default function Addcart() {
  const getInitialServicesCart = () => {
    const saved =
      localStorage.getItem("selectedServicesCart") ||
      localStorage.getItem("selectedShortTerm");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          return parsed.filter(
            (item) =>
              item.type !== "longterm" && item.service_type !== "longterm",
          );
        }
      } catch (e) {
        console.error("Failed to parse selectedServicesCart", e);
      }
    }
    return [];
  };

  const [cartItems, setCartItems] = useState(getInitialServicesCart);
  const [quantities, setQuantities] = useState(() => {
    const initial = getInitialServicesCart();
    const initialQuants = {};
    initial.forEach((item) => {
      if (item && item.id) {
        initialQuants[item.id] = item.qty || 1;
      }
    });
    return initialQuants;
  });

  const loadServicesCart = () => {
    const saved =
      localStorage.getItem("selectedServicesCart") ||
      localStorage.getItem("selectedShortTerm");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          // Exclusively filter short-term services (long term services do not enter the cart)
          const shortTermItems = parsed.filter(
            (item) =>
              item.type !== "longterm" && item.service_type !== "longterm",
          );
          setCartItems(shortTermItems);
          const initialQuants = {};
          shortTermItems.forEach((item) => {
            initialQuants[item.id] = item.qty || 1;
          });
          setQuantities(initialQuants);
        } else {
          setCartItems([]);
        }
      } catch (e) {
        console.error("Failed to parse selectedServicesCart", e);
        setCartItems([]);
      }
    } else {
      setCartItems([]);
    }
  };

  useEffect(() => {
    loadServicesCart();
    window.addEventListener("cartUpdated", loadServicesCart);
    return () => {
      window.removeEventListener("cartUpdated", loadServicesCart);
    };
  }, []);

  const getQuantity = (id) => quantities[id] || 1;

  const inc = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: (prev[id] || 1) + 1,
    }));
  };

  const dec = (id) => {
    setQuantities((prev) => {
      const current = prev[id] || 1;
      if (current <= 1) return prev;
      return {
        ...prev,
        [id]: current - 1,
      };
    });
  };

  const handleDelete = (id) => {
    const updated = cartItems.filter((item) => item.id !== id);
    setCartItems(updated);
    localStorage.setItem("selectedServicesCart", JSON.stringify(updated));
    localStorage.setItem("selectedShortTerm", JSON.stringify(updated));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const parsePrice = (priceStr) => {
    if (typeof priceStr === "number") return priceStr;
    if (!priceStr) return 0;
    const num = parseFloat(
      String(priceStr)
        .replace(/,/g, "")
        .replace(/[^\d.]/g, ""),
    );
    return isNaN(num) ? 0 : num;
  };

  const subtotal = cartItems.reduce((acc, item) => {
    return acc + parsePrice(item.price) * getQuantity(item.id);
  }, 0);

  const tax = Math.round(subtotal * 0.05 * 100) / 100;
  const total = subtotal + tax;

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className="name_p">Service Cart</span>
          </div>
        </div>
      </div>

      <div className="cart_section_content">
        <div className="container-fluid">
          {cartItems.length === 0 ? (
            <div className="empty-cart-box">
              <div className="">
                <img src={cart} alt="Your Equipment Cart is Empty" />
              </div>
              <h3>Your Service Cart is Empty</h3>
              <p className="text-muted mb-4">
                Explore our comprehensive nursing care, physiotherapy, and
                bedside attendant services, providing compassionate, reliable
                support in the comfort of your home.
              </p>
              <Link to="/home-nursingcare" className="empty-btn">
                Go to Services
              </Link>
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="add_cart_right_sec">
                  <div className="addcart_header d-flex justify-content-between align-items-center">
                    <h3>
                      <MedicalServicesOutlinedIcon className="me-2" />
                      Service in Your Cart
                    </h3>
                  </div>
                  <div className="add_cart_box services_crt_peg">
                    {cartItems.map((item) => {
                      const priceNumber = parsePrice(item.price);
                      const oldPriceNumber = parsePrice(item.oldPrice);
                      const displayDuration = item.duration
                        ? item.duration.split("(")[0].trim()
                        : "Healthcare Service";
                      return (
                        <div
                          className="main_box_crd_section ser_box_crd_sec"
                          key={item.id}
                        >
                          <div className="row">
                            <div className="col-lg-9">
                              <div className="price_and_icon_crt">
                                <div className="icons_serv_page_crt">
                                  <img src={treatment} alt="treatment" />
                                </div>
                                <div className="img_price_cart">
                                  <div className="text_price_cart">
                                    <h4 className="serv_name_serv_pg">
                                      {item.name}
                                    </h4>

                                    <div className="main_price_cart">
                                      <h4>
                                        <span>Price</span> : ₹{priceNumber}{" "}
                                      </h4>
                                      <span class="save_cart">
                                        Duration : {displayDuration}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-3">
                              <div className="delete_add_section addcart-add-part">
                                <div
                                  className="btn cross-btn "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleDelete(item.id)}
                                >
                                  X
                                </div>

                                <div className="counter d-flex align-items-center border rounded">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-light px-2"
                                    onClick={() => dec(item.id)}
                                  >
                                    -
                                  </button>
                                  <span className="px-3 fw-bold">
                                    {getQuantity(item.id)}
                                  </span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-light px-2"
                                    onClick={() => inc(item.id)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="offer_and_discont_sec">
                  <div className="summary_sec booking_box addcart-sumry-box">
                    <h3 className="summary-heading">Cart Summary</h3>

                    <div className="price_booking">
                      {cartItems.map((item) => {
                        const priceNumber = parsePrice(item.price);
                        const qty = getQuantity(item.id);
                        const itemTotal = priceNumber * qty;
                        const displayDuration = item.duration
                          ? item.duration.split("(")[0].trim()
                          : "Healthcare Service";

                        return (
                          <div
                            className="name_price_booking d-flex justify-content-between align-items-start mb-2"
                            key={item.id}
                          >
                            <div>
                              <h6 className="fw-bold mb-0 text-dark">
                                {item.name}
                              </h6>
                              <span className="text-muted small">
                                Duration: {displayDuration} | Qty: {qty}
                              </span>
                            </div>
                            <strong className="text-dark">₹ {itemTotal}</strong>
                          </div>
                        );
                      })}
                    </div>

                    <div className="price_booking">
                      <div className="name_price_booking">
                        <h4>
                          Subtotal ({cartItems.length} Service
                          {cartItems.length !== 1 ? "s" : ""})
                        </h4>
                        <h5>₹ {subtotal.toFixed(2)}</h5>
                      </div>
                      <div className="name_price_booking">
                        <h4>Tax (5% GST)</h4>
                        <h5>₹ {tax.toFixed(2)}</h5>
                      </div>
                    </div>
                    <div className="total_price_booking ">
                      <h4>Total</h4>
                      <h5>₹ {total.toFixed(2)}</h5>
                    </div>
                    {/* <div className="btns_add_crd_detail">
                      <Link to="/service-booking" className="uper_btn_acrt">
                        Proceed to Checkout
                      </Link>
                    </div> */}
                    <div className="btns_add_crd_detail d-grid gap-2 mt-3">
                      <Link
                        to="/service-booking"
                        className="btn btn-lg text-white py-2 text-center"
                        style={{
                          backgroundColor: "#13505b",
                          borderRadius: "8px",
                        }}
                      >
                        Proceed to Checkout
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}
